export const ARRAY_LIST_TO_DROPDOWN_ALGOLIA_PROPERTY_TYPE = 'ARRAY_LIST_TO_DROPDOWN_ALGOLIA_PROPERTY_TYPE'
export const IS_LOADING_ALGOLIA_PROPERTY_TYPE = 'IS_LOADING_ALGOLIA_PROPERTY_TYPE'
